import React from 'react';

function IconHamburgerMenu({ stroke = 'black', height = '30' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      id="menu-hamburger-1"
      className="custom-hamburger-menu-svg"
      stroke={stroke}
      height={height}
      strokeWidth="2"
    >
      <path
        data-name="layer2"
        fill="none"
        strokeMiterlimit="10"
        d="M2 14h60M2 32h36"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path
        data-name="layer1"
        fill="none"
        strokeMiterlimit="10"
        d="M2 50h60"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default IconHamburgerMenu;
